export const printQualifier = (q) => {
    switch (q) {
        case 'EXPECTED':
            return 'exp.';
        case 'INDICATIVE':
            return 'ind.';
        case 'MINIMUM':
            return 'min.';
        case 'UP_TO':
            return 'max.';
        case 'WILL_NOT_GROW':
            return 'wng';
        default:
            return q;
    }
};
export const printPrefix = (prefix) => {
    switch (prefix) {
        case 'HIGH':
            return 'high';
        case 'MID':
            return 'mid';
        case 'LOW':
            return 'low';
        case 'LOW_MID':
            return 'low/mid';
        case 'MID_HIGH':
            return 'mid/high';
        default:
            return '';
        //
    }
};
